module.exports = __webpack_public_path__ + "img/sitchBand200px-min.png";